module.exports = __webpack_public_path__ + "static/media/middle-school-coding-grade7.6bdd0247.jpg";